import React, { useEffect } from "react";
import "./LibrarySubjectDetail.css";
import LibrarySubjectSubDetail from "./LibrarySubjectSubDetail";
import { useState } from "react";
import axios from "../../../axios";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export default function LibrarySubjectDetail() {
  //Added this state by Kuldeep

  const navigate = useNavigate();
  const [navVal, setNavVal] = useState([]);
  const [index, setIndex] = useState();
  const [sectionId, setSection] = useState();
  const [standardId, setStandard] = useState();
  const [standardName, setStandardName] = useState();
  const [sectionName, setSectionName] = useState();
  const [subjectName, setSubjectName] = useState();

  const { state } = useLocation();

  const handleStdSec = async (sectionId, standardId) => {
    if (sectionId !== undefined && standardId !== undefined) {
      const res = await axios.get(`/api/v1/school/section/get/${sectionId}`);
      setSectionName(res.data.data.name);
      const res1 = await axios.get(`/api/v1/school/standard/get/${standardId}`);
      setStandardName(res1.data.data.name);
    }
  };

  useEffect(() => {
    //  {/* Here I have added some code which was miss because I am unable to set section and standard id  */}
    let index1 = localStorage.getItem("LibraryIndex");
    if (index1 !== undefined) {
      setIndex(index1);
    }
    let LbNav = JSON.parse(localStorage.getItem("LibraryNav"));
    setNavVal(JSON.parse(localStorage.getItem("LibraryNav")));
    setSection(LbNav[index1][0].sectionId);
    setStandard(LbNav[index1][0].standardId);
    setSubjectName(LbNav[index1][state.indexSub]?.subjectId?.name);
    handleStdSec(LbNav[index1][0].sectionId, LbNav[index1][0].standardId);
  }, []);

  return (
    <div className="m-4 overallPage ">
      <div className="d-flex gap-1 align-items-center">
        <div
          className="path_subject_library"
          onClick={() => {
            navigate("/contentLibrary");
          }}
        >
          Library &nbsp;&#62;&nbsp;
        </div>
        <div
          className="path_subject_library"
          onClick={() => {
            navigate("/contentLibrary");
          }}
        >
          {standardName} {sectionName} &nbsp;&#62;&nbsp;
        </div>
        {/* Here I have added some code which was miss */}
        <div
          className="path_subject_library"
          onClick={() => {
            navigate("/library/subjectDetails", {
              state: {
                standardId: standardId,
                sectionId: sectionId,
                indexSub: state.indexSub,
              },
            });
            // navigate(
            //   `/library/subjectDetails/${standard}/${section}`
            // );
          }}
        >
          {subjectName} &nbsp;&#62;&nbsp;
        </div>
      </div>
      <div
        style={{ height: "calc(100vh - 150px)", overflowY: "scroll" }}
        className="orange-scrollBar"
      >
        <LibrarySubjectSubDetail Subindex={state.indexSub} />
      </div>
    </div>
  );
}
